import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoDataComponent } from "./no-data.component";
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [NoDataComponent],
  imports: [
    RouterModule,
    CommonModule
  ],
  exports: [
    NoDataComponent
  ]
})
export class NoDataModule { }
